import React, { useState, Component, useRef, useEffect } from "react";

export const getThaiMonth = (monthNumber) => {
  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];
  return thaiMonths[monthNumber];
};

export const getThaiDate = (date) => {
  // Map for Thai days
  const days = [
    "วันอาทิตย์",
    "วันจันทร์",
    "วันอังคาร",
    "วันพุธ",
    "วันพฤหัสบดี",
    "วันศุกร์",
    "วันเสาร์",
  ];

  // Map for Thai months
  const months = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  // Extract parts of the date
  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];
  const year = date.getFullYear() + 543; // Convert to Thai Buddhist Era (BE)

  // Format the date in Thai style
  return `${dayName} ที่ ${day} ${monthName} ${year}`;
};

export const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1); // Increment the date by 1
  return tomorrow;
};

/////////////////////////////////////////////////////////////////////////////////////

export const toNumber = (v) => {
  const n = Number(String(v || "").replace(/[, ]/g, ""));
  return isFinite(n) ? n : 0;
};

export const togglePay = (order, phase, setPayThisRound) => (e) => {
  setPayThisRound((prev) => {
    const cur = prev[order] || { diagnosis: false, post: false, cpap: false };
    return { ...prev, [order]: { ...cur, [phase]: e.target.checked } };
  });
};
// export const togglePayTechnician = (order, phase, setPayThisRound,selectedTech,techValue) => (e) => {
//   setPayThisRound((prev) => {
//     const cur = prev[order] || { record: false, score: false };
//     return { ...prev, [order]: { ...cur, [phase]: e.target.checked } };
//   });
// };
// export const togglePayTechnician =
//   (order, phase, setPayThisRound, selectedTech, techValue,currentStatus) => (e) => {
//     setPayThisRound((prev) => {
//       const cur = prev[order] || { record: false, score: false };

//       // If selectedTech is not the same as techValue, force false
//       const value = selectedTech !== techValue ? false : e.target.checked;

//       return {
//         ...prev,
//         [order]: {
//           ...cur,
//           [phase]: value,
//         },
//       };
//     });
//   };
export const togglePayTechnician =
  (order, phase, setPayThisRound, selectedTech, techValue, currentStatus) =>
  (e) => {
    setPayThisRound((prev) => {
      const cur = prev[order] || { record: false, score: false };

      // If selectedTech is not the same as techValue, force false
      // Or if currentStatus is one of the blocked statuses, force false
      const blockedStatuses = [
        "Sleep Test Scheduled",
        "Transferred To Center",
        "Assigned",
      ];
      var value;
      if (phase === "score") {
        value =
          selectedTech !== techValue || blockedStatuses.includes(currentStatus)
            ? false
            : e.target.checked;
      } else {
        value = selectedTech !== techValue ? false : e.target.checked;
      }

      return {
        ...prev,
        [order]: {
          ...cur,
          [phase]: value,
        },
      };
    });
  };

// icons
export const PaidIcon = ({ on, title }) => (
  <i
    className={`fa ${on ? "fa-check text-warning" : "fa-times text-muted"}`}
    title={on && title ? title : undefined}
    aria-hidden="true"
  />
);

// (optional) money format
export const money = (n) => {
  const v = Number(n || 0);
  try {
    return v.toLocaleString("en-US");
  } catch {
    return String(v);
  }
};

export const parseNum = (v) => {
  const n = Number(String(v || "").replace(/[, ]/g, ""));
  return isFinite(n) ? n : 0;
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Shows a check if included in this batch, with amount under it when present
export const Phase = ({ checked, onChange, disabled, amount }) => (
  <div className="d-flex flex-column justify-content-center align-items-center">
    <div className="form-check m-0 p-0 d-flex justify-content-center align-items-center">
      <input
        className="form-check-input"
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ margin: 0 }}
      />
    </div>
    {checked && (
      <small
        className="text-muted mt-3"
        style={{ marginTop: "4px", display: "block", textAlign: "center" }}
      >
        {Number(amount || 0).toLocaleString()} THB
      </small>
    )}
  </div>
);

// utils
export const norm = (s) => (s == null ? "" : String(s).trim().toLowerCase());
export const getDoctorFrom = (b) => {
  const ext = (b && b.extendedProps) || {};
  return ext.doctorName || ext.doctor || b.doctor || "";
};
export const getTechnicianFrom = (b) => {
  const ext = (b && b.extendedProps) || {};
  return ext.technician || "";
};
export const hasText = (v) => typeof v === "string" && v.trim() !== "";
export const dateFromInputYMD = (ymd, hh = 0, mm = 0, ss = 0, ms = 0) => {
  const [y, m, d] = ymd.split("-").map((n) => parseInt(n, 10));
  return new Date(y, (m || 1) - 1, d || 1, hh, mm, ss, ms);
};
export const safeSheetName = (s) =>
  (
    String(s)
      .replace(/[:\\/\\?\\*\\[\\]]/g, " ")
      .trim() || "Sheet"
  ).slice(0, 31);
export const safeExt = (b) =>
  b && b.extendedProps && typeof b.extendedProps === "object"
    ? b.extendedProps
    : {};
export const tsToLocalString = (v) => {
  if (!v) return "";
  try {
    if (typeof v.toDate === "function") return v.toDate().toLocaleString();
    if (v instanceof Date) return v.toLocaleString();
    const d = new Date(v);
    if (!isNaN(d.getTime())) return d.toLocaleString();
  } catch {}
  return String(v);
};
// NEW: convert Firestore Timestamp/Date/string → millis
export const tsToMillis = (v) => {
  if (!v) return null;
  try {
    if (typeof v.toDate === "function") return v.toDate().getTime(); // Timestamp
    if (v.seconds != null && v.nanoseconds != null)
      return v.seconds * 1000 + Math.floor(v.nanoseconds / 1e6); // proto-like
    if (v instanceof Date) return v.getTime();
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d.getTime();
  } catch {
    return null;
  }
};
